@if (isLoading()) {
  <div class="spinner-overlay">
    <p-progressSpinner aria-label="Loading" strokeWidth="4" ></p-progressSpinner>
  </div>
}
